module.exports = __webpack_public_path__ + "media/images/person_128x128_2-80d541222a94b63cab1788e3da998c19.jpg";